import { Badge } from '@/_components';

export function CellBadge({ className, text }: { text: string | 'inactive' | 'active' | null; className?: string }) {
  const status = text === 'inactive' ? 'inactive' : 'active';

  return (
    <div className="flex items-center justify-center">
      <Badge type={status === 'inactive' ? 'error' : 'success'} className={className}>
        {status}
      </Badge>
    </div>
  );
}
